import React from 'react';
import _isEmpty from 'lodash/isEmpty';

import { TFunction } from '@lyearn/i18n';
import { Fields, FieldType } from '@/components/Form';
import FrequencyFormField, {
  DEFAULT_SCHEDULE_INFO_INPUT,
} from '@/components/Form/components/Frequency';

import SelectTemplateMenu, { EMPTY_TEMPLATE_ID } from '../SelectTemplateMenu';
import ParticipantSelection from './ParticipantSelection';
import SidebarVisibilityDetails from './SidebarVisibilityDetails';

export const initialValues = {
  assigneeId: [] as string[],
  frequency: DEFAULT_SCHEDULE_INFO_INPUT,
  templateId: EMPTY_TEMPLATE_ID,
};

export type Create1on1FormInput = typeof initialValues;

export const validateMeetingForm = (t: TFunction, values: Create1on1FormInput): any => {
  const errors: any = {};

  if (_isEmpty(values.assigneeId)) {
    errors.assigneeId = t('1on1s:Editor.AssigneeError');
  }

  return errors;
};

export const getFields = ({
  t,
  showReporteeDetails,
}: {
  t: TFunction;
  showReporteeDetails?: boolean;
}): Fields<Create1on1FormInput> => ({
  assigneeId: {
    name: 'assigneeId',
    type: FieldType.SlowCustom,
    label: t('1on1s:Modal.SetupMeetingUserField'),
    Component: ({ value, onChange, error, touched }) => {
      return (
        <>
          <ParticipantSelection error={touched && error} value={value} onChange={onChange} />
          {showReporteeDetails && value[0] ? (
            <SidebarVisibilityDetails selectedUserId={value[0]} />
          ) : null}
        </>
      );
    },
  },
  frequency: {
    name: 'frequency',
    type: FieldType.Custom,
    Component: ({ value, onChange }) => {
      return <FrequencyFormField moduleName={t('1on1s:1on1')} value={value} onChange={onChange} />;
    },
  },
  templateId: {
    name: 'templateId',
    type: FieldType.Custom,
    Component: ({ value, onChange }) => {
      return <SelectTemplateMenu value={value} onChange={onChange as TSFixMe} />;
    },
  },
});
